import { CREATE_QUIZ_ENTRY_REGRADE, REGRADE_MODAL } from '@instructure/quiz-common';
import { closeModal } from '../../common/actions/modal';
import Fetcher from '../../common/util/Fetcher';
import { processApiError, getOnErrorWithDelayedValidationMessage } from '../../common/api/helpers';
import t from '@instructure/quiz-i18n/es/format-message';
export function createQuizEntryRegrade(quizId, payload) {
  var url = "/api/quizzes/".concat(quizId, "/quiz_entry_regrades");
  var params = {
    item_id: payload.itemId,
    quiz_entry_id: payload.quizEntryId,
    points_possible: payload.pointsPossible,
    score_reconciliation: payload.scoreReconciliation,
    scoring_algorithm: payload.scoringAlgorithm,
    scoring_data: payload.scoringData
  };
  var body = JSON.stringify({
    quiz_entry_regrade: params
  });
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      cloneResponseForError: true,
      callType: CREATE_QUIZ_ENTRY_REGRADE,
      onError: getOnErrorWithDelayedValidationMessage(dispatch, t('Regrade did not run due to invalid input data.'), t('Regrade did not run.'))
    });
    var requestParams = {
      body: body
    };

    // Although the fetcher has an onError method, it's specifically for dispatching
    // redux actions (e.g. to show notifications).
    // API validation error handling doesn't go through redux, so we catch the
    // fetcher error separately below and add the necessary formatted data to it
    return fetcher.post(url, requestParams).then(function () {
      dispatch(closeModal(REGRADE_MODAL));
    })["catch"](processApiError);
  };
}